__webpack_require__.p = "/tokens-generators-update/account-setup/";